module.exports = __webpack_public_path__ + "img/bz.a4b52ad2.svg";